module.exports = __webpack_public_path__ + "img/shading.045b69f0.jpeg";